import { render } from "./PhoneDialPad.vue?vue&type=template&id=199f0bc4"
import script from "./PhoneDialPad.vue?vue&type=script&lang=js"
export * from "./PhoneDialPad.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__